<template>
    <div class="container" v-if="ListGarantidorasGeral!=''">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Contratações Vigência Finalizada</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                         <div class="status-menu">
                                    <a
                                        v-for="opt in situacoesMenu"
                                        :key="opt.id"
                                        href="#"
                                        class="btn status-btn"
                                        :class="statusClass(opt.id, true)"
                                        @click.prevent="SelecionaSituacao(opt.id)"
                                    >
                                        {{ opt.label }}
                                    </a>
                                    </div>
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ListPedidosGeralFiltro"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina"
                                    :search-value="searchValue">
                                    <template #item-garId="item">
                                        <span> {{ item.garId !== null ? ListGarantidorasGeral.filter(x=> x.garId == item.garId)[0].garNomeEmpresa : null }}</span>
                                    </template>
                                    <template #item-pedDataPedido="item">
                                        <span> {{ item.pedDataPedido !== null ? formattedDate(item.pedDataPedido) : null }}</span>
                                    </template>
                                    <template #item-pedValorTotalPedido="item">
                                        {{ item.pedValorTotalPedido !== null ? formatarValor(item.pedValorTotalPedido) : 0 }}
                                    </template>
                                       <template #item-pedSituacaoPedido="item">
                                        <button
                                            class="btn status-btn"
                                            :class="statusClass(item.pspId)"
                                        >
                                            {{ item.pedSituacaoPedido }}
                                        </button>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaContratacoesVigenciaFinalizadaView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        User:[],
        searchValue: '',
        MostraGrid: true,
        headers: [],
        Idiomas:[],
        vshowidioma: true,
        CadastroTelas:[{ cdtId: 28, cdtNome: "Contratações Vigências Finalizadas" }],
        Pedidos:[],
        ListPedidosGeral:[],
        ListPedidosGeralFiltro:[],
        ListGarantidorasGeral:[],
          situacoesMenu: [          
            { id: 10, label: "Vigência Finalizada" },
            { id: 11, label: "Vigência Renovada" },
            { id: 12, label: "Vigência Encerrada" },
            { id: 0, label: "Todos" },
            ]
    }),
    methods: {
           statusClass(pspId) {
            const map = {
            10:  "btn-warning",     // mantém (warning)
            11:  "btn-dark",        // mantém (black)
            12:  "btn-info",
            };

            return map[pspId] || "btn-light";
        },
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListPedidosGeralFiltro = this.ListPedidosGeral.filter(x=> x.pspId == value);
            }
            else{
                this.ListPedidosGeralFiltro = this.ListPedidosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditGrid(item) {
            this.$router.push('/ContratacaoVigenciaFinalizadaDetalhe/' + item.pedId);
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Id", value: "pedId", sortable: true, });
            this.headers.push({ text: "Data", value: "pedDataPedido", sortable: true, });
            this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            this.headers.push({ text: "Imobiliaria", value: "imobNome", sortable: true, });
            this.headers.push({ text: "Cliente", value: "cliNome", sortable: true, });
            this.headers.push({ text: "Documento", value: "cliDocumento", sortable: true, });
            this.headers.push({ text: "Valor", value: "pedValorTotalPedido", sortable: true, });
            this.headers.push({ text: "Situação", value: "pedSituacaoPedido", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        async Get() {

          await axios.get(`/Telas/ContratacoesVigentes/GetDadosHist`)
                .then(response => {
                    this.ListGarantidorasGeral = response.data.garantidoras.filter(x => x.garAtivo).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );

                    this.ListPedidosGeral = response.data.pedidos;     
                    this.ListPedidosGeralFiltro = this.ListPedidosGeral.sort((a, b) => {
                                                                        const valorA = parseInt(a.pedId) || 0;
                                                                        const valorB = parseInt(b.pedId) || 0;
                                                                        return valorA - valorB;
                                                                    }).reverse();
                    this.montaGrid();
                });           
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }

    .status-btn{
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 0;
  margin: 3px;
}

/* mantém warning e dark do bootstrap */

/* cores custom (todas diferentes) */
.btn-orange { background:#ff7a00; color:#fff; }
.btn-purple { background:#6f42c1; color:#fff; }
.btn-teal   { background:#20c997; color:#fff; }
.btn-pink   { background:#e83e8c; color:#fff; }

/* se usar btn-light como fallback */
.btn-light { background:#f1f3f5; color:#212529; }

</style>
